import PromotionsView from './PromotionsView';
export default PromotionsView;
